import React from 'react'

const Nodata = () => {
  return (
    <div> <h3 className="whtsclr text-center">no data found</h3> </div>
  )
}

export default Nodata